import { AddResourceToPatientPayload } from '_api/types';
import { SelectField } from 'components/molecules/formFields';
import { noop } from 'lodash';
import { usePatients, useUser } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { AddToPatientProps } from './types';

export const AddResourceToPatientForm = ({
  initValue,
  onBack = noop,
  onSubmit,
  onUpdate,
}: AddToPatientProps<AddResourceToPatientPayload>) => {
  const { isLoading, allPatientOptions, therapistPatientsOptions } = usePatients();
  const { isAdmin } = useUser();
  const isFetched = !isLoading;

  const update = async (key: any, arg: any) => {
    onUpdate(key, arg);
  };

  const selectPatientFormFields = [
    {
      component: SelectField,
      fieldKey: 'patientId',
      label: 'Select a Patient',
      options: isAdmin ? allPatientOptions : therapistPatientsOptions,
      required: true,
      xs: 12,
    },
  ];

  return isFetched ? (
    <FormBuilder
      initValues={initValue}
      formFields={selectPatientFormFields}
      onSubmit={onSubmit}
      onUpdate={update}
      onBack={onBack}
      backLabel="Cancel"
      submitLabel="Save"
    />
  ) : null;
};
